export enum NotificationType {
  MEDIA_NEW_IMAGE = 'Media.NewImage',
  CAMERA_STATUS = 'Camera.Status',
  MARKETING_EXTERNAL_URL = 'Marketing.ExternalUrl',
}

export { NotificationType as PushNotificationEventType };
